import { render, staticRenderFns } from "./PortfolioTable.vue?vue&type=template&id=553223f4&scoped=true&"
import script from "./PortfolioTable.vue?vue&type=script&lang=ts&"
export * from "./PortfolioTable.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioTable.vue?vue&type=style&index=0&id=553223f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553223f4",
  null
  
)

export default component.exports